// Named versions of one trip (docs/producto/MODELO_PRODUCTO_Y_ECONOMICO.md 2.2 d): "Save this trip" gives this
// version its name; "Start a new version" copies the whole trip — places, calendar and all — into another version,
// so trying something different never loses this one. Up to five (backend core/drafts.MAX_NAMED).
import { useEffect, useState } from "react";
import axios from "axios";
import { Bookmark, CopyPlus, Check } from "lucide-react";
import { API } from "../utils/constants";

export default function VersionBar({ draftId, sessionToken, onNewVersion }) {
  const [rows, setRows] = useState([]);
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState("");
  const [note, setNote] = useState("");
  const headers = { Authorization: `Bearer ${sessionToken}` };

  const load = () => axios.get(`${API}/drafts`, { headers }).then((r) => setRows(r.data.drafts || [])).catch(() => {});
  useEffect(() => { if (sessionToken && draftId) load(); }, [sessionToken, draftId]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!sessionToken || !draftId) return null;
  const me = rows.find((r) => r.draft_id === draftId);
  const family = me ? rows.filter((r) => r.family === me.family).sort((a, b) => String(a.created_at).localeCompare(String(b.created_at))) : [];
  const flash = (text) => { setNote(text); setTimeout(() => setNote(""), 2500); };

  const save = async () => {
    const title = name.trim();
    if (!title) return;
    await axios.put(`${API}/drafts/${draftId}`, { title }, { headers }).catch(() => {});
    setEditing(false); flash("Saved"); load();
  };
  const fork = async () => {
    try {
      const res = await axios.post(`${API}/drafts/${draftId}/versions`, {}, { headers });
      onNewVersion?.(res.data);
      flash(`Now on ${res.data.title}`);
    } catch (e) {
      flash(e?.response?.data?.detail === "versions_full" ? "Five versions is the most: remove one in My Trips first." : "That didn't work — try again.");
    }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap text-[13px]" data-testid="version-bar">
      {editing ? (
        <>
          <input value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && save()} autoFocus
            placeholder="Name this version" className="jf-field" style={{ padding: "6px 10px", fontSize: 13, minWidth: 180 }} />
          <button onClick={save} className="zen-btn zen-btn-primary text-[12px]" style={{ padding: "6px 12px" }}><Check className="w-3.5 h-3.5" /> Save</button>
        </>
      ) : (
        <>
          <span style={{ color: "var(--zen-sub)" }}>
            {me?.title || "This trip"}{family.length > 1 ? ` · version ${family.findIndex((r) => r.draft_id === draftId) + 1} of ${family.length}` : ""}
          </span>
          <button onClick={() => { setName(me?.named ? me.title : ""); setEditing(true); }} className="zen-btn zen-btn-outline text-[12px]"
            style={{ padding: "6px 12px" }} data-testid="save-trip-btn"><Bookmark className="w-3.5 h-3.5" /> Save this trip</button>
          <button onClick={fork} className="zen-btn zen-btn-outline text-[12px]" style={{ padding: "6px 12px" }} data-testid="new-version-btn">
            <CopyPlus className="w-3.5 h-3.5" /> Start a new version
          </button>
        </>
      )}
      {note && <span style={{ color: "var(--zen-accent)" }}>{note}</span>}
    </div>
  );
}
